<template>
	<div class="k-main-collection">
		<h1 class="k-page-title d-flex">
			<k-icon large color="primary" class="mr-4">fas fa-home-user</k-icon>
			<b>Welcome to {{ site_config.app_name }}!</b>
			<k-spacer />
		</h1>

		<div>
			<div class="k-parent-resources-announcements">
				<div class="k-parent-resources-student-list" :style="(user_info.role == 'parent') ? '' : 'opacity:0.5'">
					<div>
						<b style="font-size:18px">
							<k-icon color="primary" class="mr-2">fas fa-child</k-icon>Students In My Family:
						</b>
					</div>
					<ul v-if="child_count > 0 && user_info.role == 'parent'" class="mt-2">
						<li v-for="(child_data, child_email) in user_info.child_data">
							<a @click="child_selected(child_email)">
								{{ child_data.first_name }} {{ child_data.last_name }}
							</a>
						</li>
					</ul>
				</div>

				<div>
					<div class="fr-view" v-html="accessible_home_page_content"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
	props: {
	},
	data() {
		return {};
	},
	computed: {
		...mapState(['user_info', 'site_config', 'home_page_content']),
		...mapGetters(['child_count']),
		accessible_home_page_content() {
			return this.sanitize_home_page_content(this.home_page_content.parent)
		},
	},
	created() { },
	mounted() {
		// retrieve the Family View home page content, if necessary
		this.$store.dispatch('get_home_page_content', 'parent')
	},
	watch: {},
	methods: {
		sanitize_home_page_content(html) {
			if (!html) return html
			if (typeof DOMParser == 'undefined') {
				return html.replace(/<h1\b/gi, '<h2').replace(/<\/h1>/gi, '</h2>')
			}

			let parser = new DOMParser()
			let doc = parser.parseFromString(`<div>${html}</div>`, 'text/html')
			let wrapper = doc.body.firstElementChild
			if (!wrapper) return html

			for (let heading of wrapper.querySelectorAll('h1')) {
				let replacement = doc.createElement('h2')
				for (let attr of heading.attributes) replacement.setAttribute(attr.name, attr.value)
				replacement.innerHTML = heading.innerHTML
				heading.replaceWith(replacement)
			}

			for (let heading of wrapper.querySelectorAll('h1, h2, h3, h4, h5, h6')) {
				let has_text = heading.textContent && heading.textContent.trim().length > 0
				let has_meaningful_media = heading.querySelector('img, svg, picture, video')
				if (!has_text && !has_meaningful_media) heading.remove()
			}

			return wrapper.innerHTML
		},

		child_selected(child_email) {
			// when a child's name is clicked, set child_email_showing and go to the courses page
			this.$store.commit('lst_set', ['child_email_showing', child_email])
			// Also, set default Course view to 'favorites'
			if (!this.signed_in) this.$store.commit('lst_set', ['unsigned_index_view_flavor', 'favorites'])
			else this.$store.commit('lst_set', ['course_index_view_flavor', 'favorites'])
			this.$router.push({ path: '/courses' })
		},
	},
};
</script>

<style lang="scss" scoped>
.k-parent-resources-announcements {
	// display:flex;
	background-color: #fff;
	border: 6px solid #666;
	border-radius: 10px;
	padding: 12px;
	// width: 60%;
	min-height: 200px;
	max-width: 1000px;
	margin: 0 auto;
	text-align: left;

	// align-items:flex-start;
	// flex:0 1 auto;
	.fr-view {
		font-size: 16px;
	}

	.k-parent-resources-student-list {
		// flex: 1 1 auto;
		float: right;
		width: 400px;
		margin: -12px -12px 18px 18px;
		// background-color: rgba(255, 240, 200, 0.5);
		// background-color:#fff;
		border-left: 6px solid #666;
		border-bottom: 6px solid #666;
		border-radius: 0 0 0 10px;
		padding: 12px;
		white-space: nowrap;
		text-align: left;

		ul {
			margin-left: -2px;
		}

		li {
			font-size: 16px;
		}

		a:hover {
			text-decoration: underline;
		}
	}
}
</style>
